// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import AboutHeroImg from "../../asset/aboutbg.png";
// import AboutImg from "../../asset/about1.png";
// import LineImg from "../../asset/line2.png";
// import VisionImg from "../../asset/vision.png";
// import lineImg from "../../asset/line3.png";
// import uniqueImg1 from "../../asset/unique.png";
// import CircleImg from "../../asset/circle.png";
// import CardImg from "../../asset/card.png";
// import Iimage from "../../asset/cimage1.png";
// import Eimage from "../../asset/cimage2.png";
// import Timage from "../../asset/cimage3.png";
// import Vimage from "../../asset/cimage4.png";
// import Cimage from "../../asset/cimage5.png";
// import "./About.css";
// import CountUp from 'react-countup';

// const About = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="about-hero text-white"
//         style={{
//           backgroundImage: `url(${AboutHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "89vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//           padding: "0 20px",
//         }}
//       >
//         <div className="overlay"></div>
//         <div className="hero-text-container">
//           <h1 className="about-heading">Your Growth, Our Commitment</h1>
//           <p className="about-paragraph">
//             We believe every client deserves more than compliance — they deserve
//             clarity, strategy, and a partner who cares. That's why we bring together knowledge, value, and personalized service in everything we do.
//           </p>
//         </div>
//       </div>

//       {/* About Us Section */}
//       <div className="about-us-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Side - About Image */}
//             <Col md={6} className="about-image-wrapper position-relative">
//               <img src={AboutImg} alt="About Us" className="about-image" />

//               {/* Heading directly on the image */}
//               <h2 className="about-heading-on-image">
//                 <span className="about-orange">About</span>{" "}
//                 <span className="about-black">Us</span>
//               </h2>

//               {/* Decorative line */}
//               <img src={LineImg} alt="line" className="decorative-line" />
//             </Col>

//             {/* Right Side - Empty */}
//             <Col md={6}></Col>
//           </Row>
//         </Container>
//       </div>

//       {/* Vision Section */}
//       <div className="vision-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Side - Description */}
//             <Col md={8} className="vision-description">
//               <ul className="vision-points">
//                 <li>Chartered Accountancy firm headquartered in Nashik.</li>
//                 <li>
//                   Comprehensive services: Direct & Indirect Taxation, Audit &
//                   Assurance, Corporate Advisory, Finance, Subsidies, and
//                   Compliance.
//                 </li>
//                 <li>
//                   Serving corporates, MSMEs, co-operatives, trusts, start-ups,
//                   and individuals.
//                 </li>
//                 <li>Over a decade of proven experience across multiple sectors.</li>
//                 <li>
//                   Strong foundation of professional ethics, technical expertise,
//                   and client trust.
//                 </li>
//                 <li>
//                   Dedicated team ensuring smarter and timely client decisions.
//                 </li>
//                 <li>
//                   Focused on delivering optimal results in a dynamic business
//                   environment.
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Side - Vision Image */}
//             <Col md={4} className="vision-image-wrapper">
//               <img src={VisionImg} alt="Our Vision" className="vision-image" />
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* What Makes Us Unique Section */}
//       <div className="unique-section">
//         <Container>
//           <Row className="justify-content-center align-items-center text-center">
//             <Col md={12} className="unique-heading-wrapper">
//               {/* Left decorative line */}
//               <img src={lineImg} alt="line" className="unique-line left" />

//               {/* Heading */}
//               <h2 className="unique-heading">
//                 <span className="unique-orange">What</span>{" "}
//                 <span className="unique-black">Makes Us</span>{" "}
//                 <span className="unique-orange">Unique</span>
//               </h2>

//               {/* Right decorative line (mirrored) */}
//               <img src={lineImg} alt="line" className="unique-line right" />
//             </Col>
//           </Row>

//          {/* First Unique Item */}
// {/* First Unique Item - slides from left */}
// <Row className="justify-content-center mt-4">
//   <Col md={12} className="unique-item unique-item-left">
//     <img src={uniqueImg1} alt="Unique Approach" className="unique-rect" />
//     <div className="unique-text-container">
//       <h4>Experienced Professionals</h4>
//       <p>
//         A team of qualified Chartered Accountants with extensive knowledge
//         across taxation, audits, corporate advisory, and compliance.
//       </p>
//     </div>
//   </Col>
// </Row>

// {/* Second Unique Item (Mirrored Image, slides from right) */}
// <Row className="justify-content-end mt-0">
//   <Col md={12} className="unique-item unique-item-right">
//     <img
//       src={uniqueImg1}
//       alt="Unique Solutions"
//       className="unique-rect mirrored-image"
//     />
//     <div className="unique-text-container">
//       <h4>Client-Centric Approach</h4>
//       <p>
//         Every solution is tailored to meet your unique needs, whether you're
//         an individual, start-up, or established business.
//       </p>
//     </div>
//   </Col>
// </Row>

// {/* Third Unique Item - slides from left */}
// <Row className="justify-content-center mt-1">
//   <Col md={12} className="unique-item unique-item-left">
//     <img src={uniqueImg1} alt="Unique Approach" className="unique-rect" />
//     <div className="unique-text-container">
//       <h4>Timely Compliance & Accuracy</h4>
//       <p>
//         We ensure all statutory requirements are met precisely and on
//         schedule, giving you peace of mind.
//       </p>
//     </div>
//   </Col>
// </Row>

// {/* Fourth Unique Item (Mirrored Image, slides from right) */}
// <Row className="justify-content-end mt-1">
//   <Col md={12} className="unique-item unique-item-right">
//     <img
//       src={uniqueImg1}
//       alt="Unique Solutions"
//       className="unique-rect mirrored-image"
//     />
//     <div className="unique-text-container">
//       <h4>Integrity & Transparency</h4>
//       <p>
//         Our work is grounded in ethical practice and complete openness,
//         building trust with every engagement.
//       </p>
//     </div>
//   </Col>
// </Row>

// {/* Fifth Unique Item - slides from left */}
// <Row className="justify-content-center mt-1">
//   <Col md={12} className="unique-item unique-item-left">
//     <img src={uniqueImg1} alt="Unique Approach" className="unique-rect" />
//     <div className="unique-text-container">
//       <h4>Comprehensive Solutions</h4>
//       <p>
//         From accounting and tax planning to audits and business advisory, we
//         offer end-to-end services under one roof.
//       </p>
//     </div>
//   </Col>
// </Row>



//         </Container>


//        {/* Our Impact Section */}
// <div className="impact-section">
//   <Container>
//     <Row className="justify-content-center align-items-center text-center mb-5">
//       <Col md={12} className="impact-heading-wrapper">
//         {/* Left decorative line */}
//         <img src={lineImg} alt="line" className="impact-line left" />

//         {/* Heading */}
//         <h2 className="impact-heading">
//           <span className="impact-black">Our</span>{" "}
//           <span className="impact-orange">Impact</span>{" "}
//           <span className="impact-black">in</span>{" "}
//           <span className="impact-orange">Numbers</span>
//         </h2>

//         {/* Right decorative line (mirrored) */}
//         <img src={lineImg} alt="line" className="impact-line right" />
//       </Col>
//     </Row>

//    <Row className="justify-content-center impact-circle-row text-center">
//   <Col md={3} className="impact-number-item position-relative">
//     <div className="impact-circle">
//       <img src={CircleImg} alt="circle" className="impact-circle-img" />
//       <div className="impact-text">
//         <h4 className="impact-title">Happy Clients</h4>
//         <p className="impact-number">
//           <CountUp end={500} duration={2} suffix="+" />
//         </p>
//       </div>
//     </div>
//   </Col>

//   <Col md={3} className="impact-number-item position-relative">
//     <div className="impact-circle">
//       <img src={CircleImg} alt="circle" className="impact-circle-img" />
//       <div className="impact-text">
//         <h4 className="impact-title">Year Experience</h4>
//         <p className="impact-number">
//           <CountUp end={15} duration={2} suffix="+" />
//         </p>
//       </div>
//     </div>
//   </Col>

//   <Col md={3} className="impact-number-item position-relative">
//     <div className="impact-circle">
//       <img src={CircleImg} alt="circle" className="impact-circle-img" />
//       <div className="impact-text">
//         <h4 className="impact-title">Client Satisfaction</h4>
//         <p className="impact-number">
//           <CountUp end={99} duration={2} suffix="%" />
//         </p>
//       </div>
//     </div>
//   </Col>

//   <Col md={3} className="impact-number-item position-relative">
//     <div className="impact-circle">
//       <img src={CircleImg} alt="circle" className="impact-circle-img" />
//       <div className="impact-text">
//         <h4 className="impact-title">Support Available</h4>
//         <p className="impact-number">
//           <CountUp end={24} duration={2} suffix="/7" />
//         </p>
//       </div>
//     </div>
//   </Col>
// </Row>

// {/* Our Core Values Heading */}
// <Row className="justify-content-center text-center mb-5">
//   <Col md={12}>
//     <div className="core-values-heading-wrapper d-flex align-items-center justify-content-center">
//       {/* Left decorative line */}
//       <img src={lineImg} alt="line" className="core-values-line" />

//       {/* Heading */}
//       <h2 className="core-values-heading mx-3">
//         <span className="core-black">Our</span>{" "}
//         <span className="core-orange">Core Values</span>
//       </h2>

//       {/* Right decorative line (mirrored) */}
//       <img src={lineImg} alt="line" className="core-values-line mirrored" />
//     </div>
//   </Col>
// </Row>

// {/* Core Values Cards Section */}
// <Row className="justify-content-center text-center mt-4 core-values-row g-1  p-0">
//   {/* <Col className="core-value-card p-0">
//     <div className="core-value-card-img-wrapper">
//       <img src={CardImg} alt="Integrity" className="core-value-card-img" />
//       <div className="core-value-overlay">
//         <h4 className="core-value-num">01</h4>
//         <h5 className="core-value-title">Integrity</h5>
//         <p className="core-value-desc">
//           We maintain the highest professional standards, ensuring compliance with laws and regulations while protecting client interests.
//         </p>
//         <img src={Iimage} alt="Icon" className="core-value-small-img" />
//       </div>
//     </div>
//   </Col>

//   <Col className="core-value-card p-0">
//     <div className="core-value-card-img-wrapper">
//       <img src={CardImg} alt="Excellence" className="core-value-card-img" />
//       <div className="core-value-overlay">
//         <h4 className="core-value-num">02</h4>
//         <h5 className="core-value-title">Excellence</h5>
//         <p className="core-value-desc">
//           Excellence drives us to go beyond basic compliances, offering insights that empower clients to make smarter decisions.
//         </p>
//         <img src={Eimage} alt="Icon" className="core-value-small-img" />
//       </div>
//     </div>
//   </Col>

//   <Col className="core-value-card p-0">
//     <div className="core-value-card-img-wrapper">
//       <img src={CardImg} alt="Transparency" className="core-value-card-img" />
//       <div className="core-value-overlay">
//         <h4 className="core-value-num">03</h4>
//         <h5 className="core-value-title">Transparency</h5>
//         <p className="core-value-desc">
//           Transparent communications ensures accountability, allowing clients to make well-informed and confident decisions.
//         </p>
//         <img src={Timage} alt="Icon" className="core-value-small-img" />
//       </div>
//     </div>
//   </Col>

//   <Col className="core-value-card p-0">
//     <div className="core-value-card-img-wrapper">
//       <img src={CardImg} alt="Innovation" className="core-value-card-img" />
//       <div className="core-value-overlay">
//         <h4 className="core-value-num">04</h4>
//         <h5 className="core-value-title">Innovation</h5>
//         <p className="core-value-desc">
//           Our firm constantly explores new tools, technologies to stay ahead in the dynamic financial landscape.
//         </p>
//         <img src={Vimage} alt="Icon" className="core-value-small-img" />
//       </div>
//     </div>
//   </Col>

//   <Col className="core-value-card p-0">
//     <div className="core-value-card-img-wrapper">
//       <img src={CardImg} alt="Client-Centric Approach" className="core-value-card-img" />
//       <div className="core-value-overlay">
//         <h4 className="core-value-num">05</h4>
//         <h5 className="core-value-title">Client-Centric Approach</h5>
//         <p className="core-value-desc">
//           We maintain open and proactive communications, ensuring clients are informed and confident in every decision.
//         </p>
//         <img src={Cimage} alt="Icon" className="core-value-small-img" />
//       </div>
//     </div>
//   </Col> */}
//   <Col   xs={12} sm={6} md={4} lg={2} xl={2}className="core-value-card p-0">
//   <div className="core-value-card-img-wrapper">
    
//     {/* Circle Number at Top */}
//     <div className="core-value-num-circle">01</div>
    
//     <img 
//       src={CardImg} 
//       alt="Client-Centric Approach" 
//       className="core-value-card-img" 
//     />

//     {/* Overlay Text & Paragraph */}
//    <div className="core-value-overlay">
       
//         <h5 className="core-value-title">Integrity</h5>
//         <p className="core-value-desc">
//             We maintain the highest professional standards, ensuring compliance with laws and regulations  protecting.
//         </p>
//         <img src={Iimage} alt="Icon" className="core-value-small-img" />
//       </div>
//   </div>
// </Col>


// <Col xs={12} sm={6} md={4} lg={2} xl={2} className="core-value-card p-0">
//   <div className="core-value-card-img-wrapper">
    
//     {/* Circle Number at Top */}
//     <div className="core-value-num-circle">02</div>
    
//     <img 
//       src={CardImg} 
//       alt="Client-Centric Approach" 
//       className="core-value-card-img" 
//     />

//     {/* Overlay Text & Paragraph */}
//    <div className="core-value-overlay">
       
//         <h5 className="core-value-title">Excellence</h5>
//         <p className="core-value-desc">
//          Excellence drives us go beyond basic compliances, offering insights that empower clients make smarter decisions.
//         </p>
//         <img src={Eimage} alt="Icon" className="core-value-small-img" />
//       </div>
//   </div>
// </Col>


// <Col xs={12} sm={6} md={4} lg={2} xl={2} className="core-value-card">
//   <div className="core-value-card-img-wrapper">
//     {/* Circle Number */}
//     <div className="core-value-num-circle">03</div>

//     {/* Main Image */}
//     <img 
//       src={CardImg} 
//       alt="Transparency" 
//       className="core-value-card-img" 
//     />

//     {/* Overlay */}
//     <div className="core-value-overlay">
//       <h5 className="core-value-title">Transparency</h5>
//       <p className="core-value-desc">
//         Transparent communication ensures accountability, allowing clients to make well-informed and confident decisions.
//       </p>
//       <img src={Timage} alt="Icon" className="core-value-small-img" />
//     </div>
//   </div>
// </Col>



// <Col xs={12} sm={6} md={4} lg={2} xl={2} className="core-value-card p-0">
//   <div className="core-value-card-img-wrapper">
    
//     {/* Circle Number at Top */}
//     <div className="core-value-num-circle">04</div>
    
//     <img 
//       src={CardImg} 
//       alt="Client-Centric Approach" 
//       className="core-value-card-img" 
//     />

//     {/* Overlay Text & Paragraph */}
//    <div className="core-value-overlay">
       
//         <h5 className="core-value-title">Innovation</h5>
//         <p className="core-value-desc">
//           Our firm constantly explores new tools, technologies to stay ahead in the dynamic financial landscape.
//         </p>
//         <img src={Vimage} alt="Icon" className="core-value-small-img" />
//       </div>
//   </div>
// </Col>


// <Col   xs={12} sm={6} md={4} lg={2} xl={2} className="core-value-card p-0">
//   <div className="core-value-card-img-wrapper">
    
//     {/* Circle Number at Top */}
//     <div className="core-value-num-circle">05</div>
    
//     <img 
//       src={CardImg} 
//       alt="Client-Centric Approach" 
//       className="core-value-card-img" 
//     />

//     {/* Overlay Text & Paragraph */}
//    <div className="core-value-overlay">
       
//         <h5 className="core-value-title">Client-Centric Approach</h5>
//         <p className="core-value-desc">
//           We maintain open and proactive communications, ensuring clients are informed and confident in every decision.
//         </p>
//         <img src={Cimage} alt="Icon" className="core-value-small-img" />
//       </div>
//   </div>
// </Col>


// </Row>



//   </Container>
// </div>

//       </div>
//     </div>
//   );
// };

// export default About;



import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";

// ✅ Import compressed & responsive versions
import AboutHeroDesktop from "../../asset/aboutbg.webp";
import AboutHeroMobile from "../../asset/aboutbg.webp";
import AboutImg from "../../asset/about1.png";
import LineImg from "../../asset/line2.png";
import VisionImg from "../../asset/vision.png";
import lineImg from "../../asset/line3.png";
import uniqueImg1 from "../../asset/unique.png";
import CircleImg from "../../asset/circle.png";
import CardImg from "../../asset/card.png";
import Iimage from "../../asset/cimage1.png";
import Eimage from "../../asset/cimage2.png";
import Timage from "../../asset/cimage3.png";
import Vimage from "../../asset/cimage4.png";
import Cimage from "../../asset/cimage5.png";
import "./About.css";


const coreValues = [
  {
    id: "01",
    title: "Integrity",
    desc: "We maintain the highest professional standards, ensuring compliance with laws and protecting client interests.",
    icon: Iimage,
  },
  {
    id: "02",
    title: "Excellence",
    desc: "Excellence drives us beyond basic compliances, empowering clients with valuable insights.",
    icon: Eimage,
  },
  {
    id: "03",
    title: "Transparency",
    desc: "Transparent communication ensures accountability and informed decision-making.",
    icon: Timage,
  },
  {
    id: "04",
    title: "Innovation",
    desc: "We explore new tools and technologies to stay ahead in the financial landscape.",
    icon: Vimage,
  },
  {
    id: "05",
    title: "Client-Centric Approach",
    desc: "We maintain open communication to ensure clients are confident in every decision.",
    icon: Cimage,
  },
];

const uniqueItems = [
  {
    id: 1,
    title: "Experienced Professionals",
    desc: "A team of qualified Chartered Accountants with extensive knowledge across taxation, audits, corporate advisory, and compliance.",
    img: uniqueImg1,
    align: "left",
  },
  {
    id: 2,
    title: "Client-Centric Approach",
    desc: "Every solution is tailored to meet your unique needs, whether you're an individual, start-up, or established business.",
    img: uniqueImg1,
    align: "right",
  },
  {
    id: 3,
    title: "Timely Compliance & Accuracy",
    desc: "We ensure all statutory requirements are met precisely and on schedule, giving you peace of mind.",
    img: uniqueImg1,
    align: "left",
  },
  {
    id: 4,
    title: "Integrity & Transparency",
    desc: "Our work is grounded in ethical practice and complete openness, building trust with every engagement.",
    img: uniqueImg1,
    align: "right",
  },
  {
    id: 5,
    title: "Comprehensive Solutions",
    desc: "From accounting and tax planning to audits and business advisory, we offer end-to-end services under one roof.",
    img: uniqueImg1,
    align: "left",
  },
];

const About = () => {
  // ✅ Lazy load background image
  const [bgLoaded, setBgLoaded] = useState(false);
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    // Detect screen size and pick correct image
    const selectedImage =
      window.innerWidth < 768 ? AboutHeroMobile : AboutHeroDesktop;

    const img = new Image();
    img.src = selectedImage;
    img.onload = () => {
      setBgImage(selectedImage);
      setBgLoaded(true);
    };
  }, []);

  return (
    <div>
      {/* ✅ HERO SECTION */}
      <div
        className="about-hero text-white"
        style={{
          backgroundImage: bgLoaded ? `url(${bgImage})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "85vh",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "0 20px",
          backgroundColor: "#000", // fallback while loading
          transition: "background-image 0.5s ease-in-out",
        }}
      >
        {!bgLoaded && <p style={{ color: "#fff" }}>Loading...</p>}
        <div className="overlay"></div>
        <div className="hero-text-container">
          <h1 className="about-heading">Your Growth, Our Commitment</h1>
          <p className="about-paragraph">
            We believe every client deserves more than compliance — they deserve
            clarity, strategy, and a partner who cares. That's why we bring
            together knowledge, value, and personalized service in everything we
            do.
          </p>
        </div>
      </div>

      {/* ✅ ABOUT US SECTION */}
      <div className="about-us-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="about-image-wrapper position-relative">
              <img
                src={AboutImg}
                alt="About Us"
                className="about-image"
                loading="lazy"
              />
              <h2 className="about-heading-on-image">
                <span className="about-orange">About</span>{" "}
                <span className="about-black">Us</span>
              </h2>
              <img src={LineImg} alt="line" className="decorative-line" />
            </Col>
            <Col md={6}></Col>
          </Row>
        </Container>
      </div>

      {/* ✅ VISION SECTION */}
      <div className="vision-section">
        <Container>
          <Row className="align-items-center">
            <Col md={8} className="vision-description">
              <ul className="vision-points">
                <li>Chartered Accountancy firm headquartered in Nashik.</li>
                <li>
                  Comprehensive services: Direct & Indirect Taxation, Audit &
                  Assurance, Corporate Advisory, Finance, Subsidies, and
                  Compliance.
                </li>
                <li>
                  Serving corporates, MSMEs, co-operatives, trusts, start-ups,
                  and individuals.
                </li>
                <li>Over a decade of proven experience across multiple sectors.</li>
                <li>
                  Strong foundation of professional ethics, technical expertise,
                  and client trust.
                </li>
                <li>
                  Dedicated team ensuring smarter and timely client decisions.
                </li>
                <li>
                  Focused on delivering optimal results in a dynamic business
                  environment.
                </li>
              </ul>
            </Col>
            <Col md={4} className="vision-image-wrapper">
              <img
                src={VisionImg}
                alt="Our Vision"
                className="vision-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="unique-section py-5">
      <Container>
        {/* Heading */}
        <Row className="justify-content-center align-items-center text-center mb-5">
          <Col md={12} className="unique-heading-wrapper">
            <img src={lineImg} alt="line" className="unique-line left" loading="lazy" />
            <h2 className="unique-heading">
              <span className="unique-orange">What</span>{" "}
              <span className="unique-black">Makes Us</span>{" "}
              <span className="unique-orange">Unique</span>
            </h2>
            <img src={lineImg} alt="line" className="unique-line right" loading="lazy" />
          </Col>
        </Row>

        {/* Unique Items */}
        {uniqueItems.map((item, index) => (
          <Row
            key={item.id}
            className={`justify-content-center mt-4 ${
              item.align === "right" ? "justify-content-end" : ""
            }`}
          >
            <Col
              md={12}
              className={`unique-item unique-item-${item.align}`}
            >
              <img
                src={item.img}
                alt={item.title}
                className={`unique-rect ${
                  item.align === "right" ? "mirrored-image" : ""
                }`}
                loading="lazy"
              />
              <div className="unique-text-container">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </div>

      {/* ✅ IMPACT SECTION (unchanged, just added lazy loading for images) */}
      <div className="impact-section">
        <Container>
          <Row className="justify-content-center align-items-center text-center mb-5">
            <Col md={12} className="impact-heading-wrapper">
              <img src={lineImg} alt="line" className="impact-line left" />
              <h2 className="impact-heading">
                <span className="impact-black">Our</span>{" "}
                <span className="impact-orange">Impact</span>{" "}
                <span className="impact-black">in</span>{" "}
                <span className="impact-orange">Numbers</span>
              </h2>
              <img src={lineImg} alt="line" className="impact-line right" />
            </Col>
          </Row>

          <Row className="justify-content-center impact-circle-row text-center">
            {[
              { title: "Happy Clients", value: 500, suffix: "+" },
              { title: "Year Experience", value: 15, suffix: "+" },
              { title: "Client Satisfaction", value: 99, suffix: "%" },
              { title: "Support Available", value: 24, suffix: "/7" },
            ].map((item, index) => (
              <Col key={index} md={3} className="impact-number-item position-relative">
                <div className="impact-circle">
                  <img
                    src={CircleImg}
                    alt="circle"
                    className="impact-circle-img"
                    loading="lazy"
                  />
                  <div className="impact-text">
                    <h4 className="impact-title">{item.title}</h4>
                    <p className="impact-number">
                      <CountUp end={item.value} duration={2} suffix={item.suffix} />
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
            <div className="core-values-section py-5">
      <Container>
        {/* Heading */}
        <Row className="justify-content-center text-center mb-5">
          <Col md={12}>
            <div className="core-values-heading-wrapper d-flex align-items-center justify-content-center">
              <img src={lineImg} alt="line" className="core-values-line" loading="lazy" />
              <h2 className="core-values-heading mx-3">
                <span className="core-black">Our</span>{" "}
                <span className="core-orange">Core Values</span>
              </h2>
              <img src={lineImg} alt="line" className="core-values-line mirrored" loading="lazy" />
            </div>
          </Col>
        </Row>

        {/* Cards */}
        <Row className="justify-content-center text-center g-3 px-2">
          {coreValues.map((value) => (
            <Col key={value.id} xs={12} sm={6} md={4} lg={2} className="core-value-card">
              <div className="core-value-card-img-wrapper">
                <div className="core-value-num-circle">{value.id}</div>
                <img
                  src={CardImg}
                  alt={value.title}
                  className="core-value-card-img"
                  loading="lazy"
                />
                <div className="core-value-overlay">
                  <h5 className="core-value-title">{value.title}</h5>
                  <p className="core-value-desc">{value.desc}</p>
                  <img
                    src={value.icon}
                    alt={`${value.title} icon`}
                    className="core-value-small-img"
                    loading="lazy"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
      </div>
    </div>
  );
};

export default About;
